/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Link,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core'
import classnames from 'classnames'
import React from 'react'
import CountUp from 'react-countup'
import { Link as RouterLink } from 'react-router-dom'
import colors from '../../../assets/colors'
import Icon from '@mdi/react'
import { useSelector } from 'react-redux'
import { hasRole } from '../../../util/utils'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    borderRadius: '10px',
    border: `1px solid ${colors.graylight}`,
    height: 'auto',
  },
  aditionalBox: {
    padding: '8px 24px',
    color: colors.primary,
    fontSize: '12px',
    lineHeight: '12px',
  },
  rowTotal: {
    color: '#FFF',
    fontSize: '12px',
    backgroundColor: colors.primary,
    padding: '4px',
    borderRadius: '0px 0px 10px 10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    paddingRight: '20px',
    width: '100%',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '.5rem',
  },
  cardTitle: {
    textAlign: 'start',
  },
  cardTitleLink: {
    cursor: 'pointer',
    textAlign: 'start',
    color: colors.primary,
    textTransform: 'captalize',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '12px',
    margin: '.5em 0',
    textDecoration: 'underline',
    letterSpacing: '.09em',
  },
  value: {
    fontSize: '22px',
    lineHeight: '22px',
    fontWeight: '700',
    color: colors.graylight,
    marginRight: theme.spacing(1),
  },
  differenceValue: {
    color: '#3AA873',
    marginRight: theme.spacing(1),
  },
  differenceValueNegative: {
    color: '#C15858',
    marginRight: theme.spacing(1),
  },
  divider: {
    height: '80%',
    border: `1px solid ${colors.lightGray}`,
  },
}))

const CardSection = ({
  title,
  icon,
  data,
  isLinkCard = false,
  isMonetary = false,
  isLinkRelatory = false,
  showPercentage = false,
  finalDate = '',
  startDate = '',
}) => {
  const role = useSelector(state => state.auth.role)
  const user = useSelector(state => state.auth.user)

  const classes = useStyles()

  const contUp = money => {
    return (
      <CountUp
        end={money}
        duration={0.9}
        decimals={2}
        decimal=","
        // prefix="R$"
        separator="."
      />
    )
  }

  const attendancesPath = element => {
    return `/relatory-services?status=${
      element?.type
    }&finalDate=${finalDate}&startDate=${startDate}${
      !hasRole('gerente_lavanderia', role) && hasRole('atendente', role)
        ? `&attendance=${user?.id}`
        : ''
    }`
  }

  const relatoryPath = element => {
    return `/relatory-schedules?status=${
      element?.type
    }&finalDate=${finalDate}&startDate=${startDate}${
      !hasRole('gerente_lavanderia', role) && hasRole('atendente', role)
        ? `&attendance=${user?.id}`
        : ''
    }`
  }

  const cardLinkable = isLinkCard || isLinkRelatory

  return (
    <>
      <Grid item container xs={12}>
        <Grid item container className={classes.root}>
          <Grid
            item
            container
            md={3}
            sm={12}
            justifyContent="space-between"
            alignItems="center"
            style={{
              padding: '4px 12px',
            }}
          >
            <Grid item>
              <Typography
                variant="h4"
                color="secondary"
                style={{
                  fontSize: '17px',
                  color: colors.primary,
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: '12px',
                  textAlign: 'start',
                }}
              >
                <Icon path={icon} size={2} color={colors.graylight} />
                {title}
              </Typography>
            </Grid>

            <Grid item className={classes.divider} />
          </Grid>

          <Grid item container md={9} alignItems="center">
            {data?.map((element, index) => {
              // no render total and ticket
              if (element?.type === 'total' || element?.type === 'ticket')
                return

              return (
                <Grid
                  item
                  key={index}
                  xs={12}
                  sm={4}
                  md={4}
                  style={{
                    padding: '8px',
                    height: '100%',
                    position: 'relative',
                  }}
                >
                  {showPercentage && (
                    <Box
                      style={{
                        padding: '2px 6px',
                        borderRadius: '12px',
                        color: element?.percentage
                          ? colors.sucess
                          : colors.textGray,
                        backgroundColor: element?.percentage
                          ? colors.bgSucess
                          : colors.lightGray,
                        fontSize: '12px',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        position: 'absolute',
                        top: '8px',
                        right: '20px',
                        gap: '12px',
                      }}
                    >
                      <CircularProgress
                        variant="determinate"
                        thickness={6}
                        color="inherit"
                        value={parseFloat(element?.percentage) || 0}
                        size={15}
                      />
                      {element?.percentage || '0'}%
                    </Box>
                  )}

                  <Grid container alignItems="center">
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          fontSize: '12px',
                          color: colors.primary,
                          textAlign: 'start',
                        }}
                      >
                        R$
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="flex-start">
                      {isMonetary ? (
                        <Typography
                          color="textPrimary"
                          variant="h3"
                          className={classnames(
                            {
                              [classes.differenceValue]: element.value > 0,
                              [classes.differenceValueNegative]:
                                element.value < 0,
                            },
                            classes.value
                          )}
                        >
                          {contUp(element.value)}
                        </Typography>
                      ) : (
                        <Typography color="textPrimary" variant="h3">
                          {element.value}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {cardLinkable &&
                      element?.type != 'total' &&
                      element?.type != 'ticket' ? (
                        <Link
                          component={RouterLink}
                          to={
                            isLinkCard
                              ? attendancesPath(element)
                              : relatoryPath(element)
                          }
                          color="textSecondary"
                          gutterBottom
                          variant="h6"
                          className={classes.cardTitleLink}
                        >
                          {element.name}
                        </Link>
                      ) : (
                        <Typography
                          color="textSecondary"
                          gutterBottom
                          variant="h6"
                          className={classes.cardTitle}
                        >
                          {element.name}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )
            })}
          </Grid>

          {data?.map((element, index) => {
            // render total
            if (element?.type === 'total') {
              return (
                <Box className={classes.rowTotal}>
                  <span>{element?.name || 'Total'}:</span>

                  <Box
                    style={{
                      width: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <span>R$</span>
                    <Typography
                      color="textPrimary"
                      variant="h3"
                      className={classes.value}
                      style={{ color: '#FFFF', textAlign: 'start' }}
                    >
                      {contUp(element.value)}
                    </Typography>
                  </Box>
                </Box>
              )
            }
          })}
        </Grid>
      </Grid>
    </>
  )
}

export default CardSection
